import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import VueMeta from 'vue-meta';

Vue.use(VueRouter);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "index" */ '../views/index.vue'),
  },
  {
    path: '/catalog-editor',
    name: 'catalog-editor',
    component: () => import(/* webpackChunkName: "index" */ '../views/CatalogEditorView.vue'),
  },
  {
    path: '/editor/:id',
    name: 'document-editor',
    component: () => import(/* webpackChunkName: "index" */ '../views/DocumentEditorView.vue'),
  },
  {
    path: '/:id',
    name: 'document-viewer',
    component: () => import(/* webpackChunkName: "index" */ '../views/DocumentViewerView.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
